export const LoginPreloadData = () => {
  return {};
};

export type LoginPreloadDataType = ReturnType<typeof LoginPreloadData>;
